import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';
import { sortable } from 'modules/sortable';

import Info, { infoShape } from '../../components/Info';

import { infoRequest, updateInfoOrder } from '../../services/actions';
import { selectInfo, selectInfoListPending } from '../../services/selectors';

export default compose(
    connect(
        (state, { id }) => ({
            initialItems: selectInfo(state, id),
            showLoader: selectInfoListPending(state, id),
        }),
        (dispatch, { id }) => ({
            read: () => {
                dispatch(infoRequest(id));
            },
            onSortEnd: info => {
                dispatch(updateInfoOrder(id, info));
            },
        }),
    ),
    routeDependencies(),
    loadable,
    sortable({
        shape: infoShape,
        showNoData: false,
        settings: {
            lockAxis: 'y',
            axis: 'y',
        },
    }),
)(Info);
